export default __webpack_public_path__ + "static/media/lineupcomparison.08d968dc.png";